<template>
  <div class="account-page budgets">
    <AccountPanel title="Lista budżetów">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">nazwa</th>
              <th scope="col">wartość</th>
              <th scope="col">wykorzystano</th>
              <th scope="col">pozostało</th>
              <th scope="col">data rozpoczęcia</th>
              <th scope="col">data zakończenia</th>
              <th class="col-sm-1"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in company.budgets">
              <td v-if="!data.edit" scope="col">{{data.budget.name}}</td>
              <td v-else scope="col">
                <input type="text" class="form-control" v-model="data.budget.name" />
              </td>
              <td v-if="!data.edit" scope="col">
                <div class="float-right">{{formatPrice(data.budget.value)}} zł</div>
              </td>
              <td v-else scope="col">
                <input
                  type="number"
                  class="form-control"
                  step="0.01"
                  min="0"
                  v-model="data.budget.value"
                />
              </td>
              <td scope="col">
                <div class="float-right">{{formatPrice(data.budget.used_value)}} zł</div>
              </td>
              <td scope="col">
                <div
                  class="float-right"
                >{{formatPrice(data.budget.value - data.budget.used_value)}} zł</div>
              </td>
              <td v-if="!data.edit" scope="col" class="text-center">{{data.budget.start}}</td>
              <td v-else scope="col">
                <input type="date" class="form-control" v-model="data.budget.start" />
              </td>
              <td v-if="!data.edit" scope="col" class="text-center">{{data.budget.finish}}</td>
              <td v-else scope="col">
                <input type="date" class="form-control" v-model="data.budget.finish" />
              </td>
              <td col-sm-1>
                <content-save-icon
                  v-if="data.edit"
                  @click.native="saveBudget(data.budget)"
                  title="Zapisz"
                ></content-save-icon>
                <pencil-icon v-else @click.native="unlockEdit(data)" title="Edytuj"></pencil-icon>
                <delete-icon @click.native="removeBudget(data.budget)" title="Usuń"></delete-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </AccountPanel>
  </div>
</template>

<script>
import { mapState } from "vuex";

import AccountPanel from "./AccountPanel.vue";

import PencilIcon from "vue-material-design-icons/pencil.vue";
import DeleteIcon from "vue-material-design-icons/delete.vue";
import ContentSaveIcon from "vue-material-design-icons/contentSave.vue";

export default {
  components: {
    AccountPanel,
    ContentSaveIcon,
    DeleteIcon,
    PencilIcon
  },
  computed: {
    ...mapState({
      company: state => state.company
    })
  },
  data() {
    return {
      showForm: false
    };
  },
  methods: {
    formatPrice(value) {
      let currValue = value;
      let val = (currValue / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    unlockEdit(data) {
      data.edit = true;
    },
    saveBudget(budget) {
      this.$store.dispatch("company/editbudget", this.extractedValues(budget));
    },
    removeBudget(budget) {
      this.$store.dispatch(
        "company/removebudget",
        this.extractedValues(budget)
      );
    },
    extractedValues(data) {
      const result = {};
      for (let field in data) {
        result[field] = data[field];
      }
      return result;
    },
    closeForm() {
      this.showForm = false;
    }
  },
  async beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }

    await this.$store.dispatch("company/budgets");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/BudgetList.vue